import { Button, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { useState } from 'react';
import { DropDown, DropDownItem } from '../../../Dropdown';

type AddProcessorProps = {
  processors: string[];
  onProcessorAdd: (type: string) => void;
};
const AddProcessor: FC<AddProcessorProps> = ({ onProcessorAdd, processors }) => {
  const [processorType, setProcessorType] = useState<string | undefined>(undefined);

  // const addProcessor = () => {
  //   const initVal = obj => {
  //     const defaultNativeValues = {
  //       string: undefined,
  //       boolean: false,
  //       number: undefined
  //     };
  //     if (obj?.defaultValue) {
  //       return obj.defaultValue;
  //     }
  //     if (!obj?.defaultValue && obj?.options?.length === 1) {
  //       return obj.options[0];
  //     }

  //     return defaultNativeValues[obj?.nativeType];
  //   };

  //   const initProcessorProps = properties => {
  //     return Object.keys(properties)
  //       .filter(k => k !== 'references')
  //       .reduce((acc, val) => {
  //         return {
  //           ...acc,
  //           [properties[val].name]:
  //             properties[val].type !== 'field'
  //               ? initProcessorProps(properties[val].properties)
  //               : initVal(properties[val])
  //         };
  //       }, {});
  //   };

  //   if (processorType) {
  //     const properties = processorProperties[processorType];
  //     onProcessorAdd(initProcessorProps(properties));
  //     setProcessorType(undefined);
  //   }
  // };
  return (
    <FlexLayout justifyContent="space-between" alignItems="center" mt="xs" mb="xs" p="xs" flexWrap="nowrap">
      <DropDown defaultValue={processorType} placeholder="Select" onChange={setProcessorType}>
        {processors?.map(processor => (
          <DropDownItem value={processor} key={processor}>
            <H4 style={{ textTransform: 'capitalize' }}>{processor}</H4>
          </DropDownItem>
        ))}
      </DropDown>
      <Button
        variant="border"
        disabled={!processorType}
        onClick={() => {
          if (processorType) {
            onProcessorAdd(processorType);
          }
        }}
        ml="md"
      >
        <Icon src="add" stroke="transparent" mr="xs" />
        Add
      </Button>
    </FlexLayout>
  );
};

export default AddProcessor;
